<header>
    <label class="close_button" (click)="close()">x</label>
    <div class="header">
        <h1 class="gridcaption"> Logs </h1>
    </div>
</header>
<div class="body">
    <label *ngIf="errormsg" class="errormsg"> {{errormsg}} </label>
    <ag-grid-angular style="width:100%;height:340px;" id="LIOS-GRID" class="ag-theme-balham" [theme]="'legacy'"
        (gridReady)="onGridReady($event);" (window:resize)="sizeToFit()" [animateRows]="true"
        [defaultColDef]="defaultColDef" [columnDefs]="columnDefs" [rowData]="rowData"  
        [context]="context" [icons]="icons">
    </ag-grid-angular>


</div>